import { render } from "./Article.view.vue?vue&type=template&id=e3ffcf46"
import script from "./Article.view.vue?vue&type=script&lang=js"
export * from "./Article.view.vue?vue&type=script&lang=js"

import "./Article.view.vue?vue&type=style&index=0&id=e3ffcf46&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__